import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useCurrentConfigData from '../../../../hooks/dashboard/dashboardLoading/useCurrentConfig';
import useBenchmark from '../../../../hooks/dashboard/performance-monitoring/useBenchmark';
import {
  PerformanceBenchmarkDataType,
  PerformanceBenchmarkInitialValues,
  PerformanceBenchmarkSchema,
} from '../../../../models/dashboard/performance-monitoring/performance-benchmark';
import { useAppSelector } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { PercentageOnlyInputField } from '../../../FormCom/PercentageOnlyInputField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';

const PerformanceBenchmarkModal = () => {
  const modalContext = useContext(ModalContext);
  const { currentConfigData } = useAppSelector(
    (state) => state.currentConfigData,
  );
  const { setBenchmark, loading } = useBenchmark();
  const { getCurrentConfigData } = useCurrentConfigData();

  const successActionFn = () => {
    modalContext?.setShowModal(false);
  };

  const onSubmit = (value: PerformanceBenchmarkDataType) => {
    setBenchmark(value, () => {
      modalContext?.setShowSuccessComponent(true);
      modalContext?.setSuccessDescription(
        `Performance benchmark set to ${value.benchmark}th percentile.`,
      );
      getCurrentConfigData();
    });
  };

  if (currentConfigData?.baseline && currentConfigData.baseline > 0) {
    PerformanceBenchmarkInitialValues.benchmark = String(
      currentConfigData.baseline,
    );
  }

  return (
    <ModalContainer
      label='Set Performance Benchmark'
      description='Set the minimum percentile threshold (baseline)for company performance evaluation.'
      successComponent={() => (
        <PlainSuccessModal
          successActionFn={successActionFn}
          successLabel='Benchmark updated successfully'
          description={modalContext?.successDescription ?? ''}
          btnLabel='Close'
        />
      )}
      showSuccessComponent={modalContext?.showSuccessComponent}
    >
      <FormComponent
        initialValues={PerformanceBenchmarkInitialValues}
        schema={PerformanceBenchmarkSchema}
        onSubmit={onSubmit}
        className={'large-gap'}
      >
        <PercentageOnlyInputField
          label=''
          name='benchmark'
          id='benchmark'
          type='text'
          placeholder='0'
        />

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Save Benchmark
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default PerformanceBenchmarkModal;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
